module.exports = __webpack_public_path__ + "static/media/ic-plc-attachment.4cc22ef0.svg";